export const TRANS = {
  toc: { en: 'Table of contents', fi: 'Sisällysluettelo' },
};
